import axios from 'axios' //引用axios
import { Promise } from 'es6-promise' //引入Promise

// axios 配置
let reg = /^localhost+/;
let reg2 = /^127\.0\.0\.1+/;
let reg3 = /^demo.mall.10010.com/;
let host = window.location.host; //主机
let path = "http://demo.mall.10010.com:8104";
let loginUrl = 'http://dev3000.uac.10010.com/oauth2/new_auth?display=wap&page_type=06&app_code=ECS-JF&redirect_uri=http://demo.mall.10010.com:8104/jf-mall/deal&app_code=ECS-JF&state=' + window.location.href;
if(reg.test(host) || reg2.test(host)) {
  //若本地项目调试使用
  axios.defaults.baseURL = '/api';
} else if(reg3.test(host)) {
  // 测试环境请求地址
  axios.defaults.baseURL = "http://demo.mall.10010.com:8104";
} else {
  //线上请求地址
  axios.defaults.baseURL = "https://m.jf.10010.com";
  path = "https://m.jf.10010.com";
  loginUrl = 'https://uac.10010.com/oauth2/new_auth?display=wap&page_type=06&redirect_uri=http://m.jf.10010.com/deal&app_code=ECS-JF&state=' + window.location.href;
}

axios.defaults.timeout = 10000; //设置超时时间

// http response 拦截器（所有接收到的请求都要从这儿过一次）
// axios.interceptors.response.use(
//   response => {
//     if (response.data.resultcode && response.data.resultcode === "1001") {
//       window.location.href = loginUrl;
//       return;
//     } else {
//       return response;
//     }
//   },
//   error => {
//     return Promise.reject(error.response.data)
//   });

export default axios;

/**
 * fetch 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function fetch(url, params = {}) {

  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, config)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
  })
}

/**
 * patch 方法封装
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
  })
}

/**
 * put 方法封装
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
  })
}



// WEBPACK FOOTER //
// ./src/util/http.js